// One row per production date, shift, crew and product size. The numbers summarise
// the gap time between consecutive bars leaving the straightener, aggregated hourly
// by KPI.UpsertStraightenerRuns into KPI.FactTableStraightenerRuns.
export interface StraightenerKpiRow {
	// A plain date on the new branch and a datetime on the legacy one, so it is cut
	// to ten characters rather than converted.
	ProductionDate: string | null;
	// "D" or "N".
	ProductionShift: string | null;
	// "A" to "D". Null when the shift had no crew on the roster.
	CrewId: string | null;
	// Null for rows the straightener ran without a product size resolved.
	ProductSize: string | null;
	// Gap events in the group, one per bar.
	Count: number | null;
	// Seconds between one bar and the next. 300 is the ceiling the tracking records.
	GapTimeMin: number | null;
	GapTimeMax: number | null;
	GapTimeAvg: number | null;
	// Feet per minute: what the line was set to, and what it measured.
	FPMSet: number | null;
	FPMCalibrated: number | null;
}

export interface ProductSizeOption {
	Id: number;
	Name: string;
}

// The legacy dropdown reads All, None, then the fetched sizes. "All" is a real
// entry there, not an empty field, so it is one here too; picking it sends null.
// "None" reaches the rows whose ProductSizeId is null: the procedure reads -1 as
// "no product size".
export const ALL_PRODUCT_SIZE_ID = -2;
export const NO_PRODUCT_SIZE_ID = -1;

export const ALL_PRODUCT_SIZE_OPTION: ProductSizeOption = {
	Id: ALL_PRODUCT_SIZE_ID,
	Name: "All",
};

export const NO_PRODUCT_SIZE_OPTION: ProductSizeOption = {
	Id: NO_PRODUCT_SIZE_ID,
	Name: "None",
};

// Both lists are hardcoded in the legacy screen too: neither is fetched.
export const SHIFT_OPTIONS = ["D", "N"] as const;
export const CREW_OPTIONS = ["A", "B", "C", "D"] as const;
